import { render, staticRenderFns } from "./TermsWriteLink.vue?vue&type=template&id=346f8acb&scoped=true&"
import script from "./TermsWriteLink.vue?vue&type=script&lang=js&"
export * from "./TermsWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f8acb",
  null
  
)

export default component.exports